<template>
  <component :is="tag" class="file-icon">
    <span :class="`file-icon__icon file-icon__icon--${type}`" v-html="fileFilledIcon" />
    <span :class="`file-icon__label file-icon__label--${type}`">{{ uppercaseExtension }}</span>
  </component>
</template>

<script setup lang="ts">
import { fileTypeFromFileName, extensionFromName } from '@lib/files';
import fileFilledIcon from '@icons/other2/file-filled.svg';
import { computed } from 'vue';

const props = withDefaults(defineProps<{ fileName: string; tag?: string }>(), {
  tag: 'div',
});

const type = computed(() => fileTypeFromFileName(props.fileName));
const uppercaseExtension = computed(() => extensionFromName(props.fileName).toUpperCase());
</script>

<style scoped lang="scss">
@import '@styles/variables';

// File Icon ---------------------------------------------------------------
.file-icon {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  max-height: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  user-select: none;
  z-index: 0;

  &__icon {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0 auto auto 0;
    z-index: -1;

    :deep(svg) {
      fill: #878787;
    }

    &--powerpoint {
      :deep(svg) {
        fill: #cd4a34;
      }
    }

    &--pdf {
      :deep(svg) {
        fill: #e52525;
      }
    }

    &--excel {
      :deep(svg) {
        fill: #2e7d32;
      }
    }

    &--word {
      :deep(svg) {
        fill: #1565c0;
      }
    }

    &--illustrator {
      :deep(svg) {
        fill: #ff9a00;
      }
    }
  }

  &__label {
    width: 100%;
    color: #fff;
    position: absolute;
    top: calc(50% - 0.4rem);
    font-size: 0.7rem;
    line-height: 1.1rem;
    font-weight: 800;
    letter-spacing: 0.5px;
    text-align: center;

    &--illustrator {
      color: #330001;
    }
  }
}
</style>
